var render = function () {
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', {
    staticClass: "page-container"
  }, [_c('div', {
    attrs: {
      "id": "searchArea"
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.dataForm
    },
    nativeOn: {
      "keyup": function keyup($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.getDataList(1);
      }
    }
  }, [_c('div', {
    staticClass: "clearfix"
  }, [_c('div', {
    staticClass: "fl pb10"
  }, [_vm.isAuth('sys:user:sync') ? _c('el-button', {
    staticClass: "fs14",
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.synchronous
    }
  }, [_vm._v("Sync")]) : _vm._e()], 1), _c('div', {
    staticClass: "fr"
  }, [_c('el-form-item', [_c('el-select', {
    staticClass: "wd150",
    attrs: {
      "clearable": "",
      "placeholder": "Role Name"
    },
    model: {
      value: _vm.dataForm.roleId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "roleId", $$v);
      },
      expression: "dataForm.roleId"
    }
  }, _vm._l(_vm.roleList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.name,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    staticClass: "wd150",
    attrs: {
      "placeholder": "Nick Name",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.nickname,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "nickname", $$v);
      },
      expression: "dataForm.nickname"
    }
  })], 1), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Staff No.",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.staffNo,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "staffNo", $$v);
      },
      expression: "dataForm.staffNo"
    }
  })], 1), _c('el-form-item', [_c('el-input', {
    directives: [{
      name: "regexFilter",
      rawName: "v-regexFilter",
      value: _vm.halfWidthRegex,
      expression: "halfWidthRegex"
    }],
    attrs: {
      "placeholder": "Position",
      "clearable": ""
    },
    model: {
      value: _vm.dataForm.position,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "position", $$v);
      },
      expression: "dataForm.position"
    }
  })], 1), _c('el-form-item', [_c('el-select', {
    attrs: {
      "filterable": "",
      "clearable": "",
      "placeholder": "Supplier"
    },
    model: {
      value: _vm.dataForm.supplierId,
      callback: function callback($$v) {
        _vm.$set(_vm.dataForm, "supplierId", $$v);
      },
      expression: "dataForm.supplierId"
    }
  }, _vm._l(_vm.allSupplierList, function (item) {
    return _c('el-option', {
      key: item.id,
      attrs: {
        "label": item.companyName,
        "value": item.id
      }
    });
  }), 1)], 1), _c('el-form-item', [_c('el-button', {
    directives: [{
      name: "debounce",
      rawName: "v-debounce"
    }],
    attrs: {
      "icon": "el-icon-search",
      "type": "primary",
      "plain": ""
    },
    on: {
      "click": function click($event) {
        return _vm.getDataList(1);
      }
    }
  }, [_vm._v("Search")])], 1)], 1)])])], 1), _c('div', [_c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: _vm.dataListLoading,
      expression: "dataListLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "max-height": "680",
      "data": _vm.dataList
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": "id",
      "align": "center",
      "width": "70",
      "label": "ID",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "email",
      "align": "center",
      "width": "200",
      "label": "Email",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "nickname",
      "align": "center",
      "width": "120",
      "label": "Nick Name",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "staffNo",
      "align": "center",
      "width": "120",
      "label": "Staff No.",
      "fixed": "left"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "position",
      "align": "center",
      "width": "150",
      "label": "Position"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "employers",
      "align": "center",
      "width": "150",
      "label": "Employer"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [scope.row.employers ? _c('p', [_vm._v(_vm._s(scope.row.employers.join(", ")))]) : _vm._e()];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "align": "center",
      "width": "150",
      "label": "Phone"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "roleList",
      "align": "center",
      "width": "180",
      "label": "Role",
      "formatter": _vm.roleListToStringFormatter
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "createTime",
      "align": "center",
      "width": "180",
      "label": "Register Date"
    }
  }), _c('el-table-column', {
    attrs: {
      "prop": "status",
      "align": "center",
      "width": "100",
      "label": "Status",
      "formatter": _vm.enableAndDisableFormat
    }
  }), _c('el-table-column', {
    attrs: {
      "align": "center",
      "label": "Supplier",
      "width": "200"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_c('p', [_vm._v(_vm._s(_vm.supplierAbbrDeduplicateFormat(scope.row.supplierList)))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "label": "Replacement User",
      "align": "center",
      "width": "156"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        var _scope$row$replacemen;

        return [_c('p', [_vm._v(_vm._s(((_scope$row$replacemen = scope.row.replacementUser) === null || _scope$row$replacemen === void 0 ? void 0 : _scope$row$replacemen.nickname) || ""))])];
      }
    }])
  }), _c('el-table-column', {
    attrs: {
      "prop": "remark",
      "align": "center",
      "min-width": "150",
      "label": "Remark",
      "show-overflow-tooltip": ""
    }
  }), _c('el-table-column', {
    attrs: {
      "fixed": "right",
      "align": "center",
      "width": "120",
      "label": "Action"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function fn(scope) {
        return [_vm.isAuth('sys:user:update') ? _c('el-button', {
          staticClass: "fwb",
          attrs: {
            "type": "text"
          },
          on: {
            "click": function click($event) {
              return _vm.editHandle(scope.row);
            }
          }
        }, [_vm._v("Roles")]) : _vm._e()];
      }
    }])
  })], 1)], 1), _c('pagination', {
    attrs: {
      "current": _vm.current,
      "pageSize": _vm.pageSize,
      "totalCount": _vm.totalCount
    },
    on: {
      "size-change": _vm.sizeChangeHandle,
      "current-change": _vm.currentChangeHandle
    }
  }), _c('add-or-update', {
    ref: "addOrUpdate",
    attrs: {
      "allSupplierList": _vm.allSupplierList
    },
    on: {
      "refreshDataList": _vm.updateHandle
    }
  })], 1);
}
var staticRenderFns = []

export { render, staticRenderFns }